import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { Menu as MenuIcon } from "@mui/icons-material";

export default function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Mobile hamburger menu button */}
      <button
        className="sm:hidden fixed top-4 left-4 z-40 p-2 bg-white border border-gray-200 rounded-full shadow-md"
        onClick={handleSidebarToggle}
      >
        <MenuIcon className="text-primaryText" />
      </button>

      {/* Sidebar - always open on desktop, toggleable on mobile */}
      <div className="fixed left-0 top-0 h-screen z-30">
        <Sidebar
          collapsed={false}
          isSidebarOpen={isSidebarOpen}
          onClose={handleSidebarClose}
        />
      </div>

      {/* Main content */}
      <div className="flex-1 min-w-0 transition-all duration-300 sm:ml-64 pt-10 sm:pt-0">
        <div className="p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
